import React, { FC } from 'react';
import ExpenseCategoryFormField from './ExpenseCategoryFormField';

const RMCategoryFormField: FC<any> = (props): React.ReactElement => {
	return <ExpenseCategoryFormField categoryType="rm" {...props} />;
};

export default RMCategoryFormField;
